import React from 'react';
import { guidedSearchNavUrl } from '../../../utils/url';
import DynamicCarousel from '../../common/dynamic_carousel';
import './index.scss';

const GuidedSearchNav = ({ query, pageCtxId, terms = [] }) => {

    const renderTerm = ({ term }) => {
        const url = guidedSearchNavUrl(term, query, pageCtxId);

        return <a key={term} href={url}>{term}</a>;
    };

    if (terms.length <= 0) {
        return null;
    }

    return (
        <div className="guided-search-nav">
            <DynamicCarousel terms={terms} renderTerm={renderTerm}/>
        </div>
    );
};

export default GuidedSearchNav;
